<template>
  <div class="c-single-image-drawer">
    <div class="c-single-image-drawer-header">
      <button
        class="c-single-image-drawer-close-button"
        @click="close()"
      >
        <md-icon>
          keyboard_tab
        </md-icon>
      </button>
      <span>{{ cloudflareImage?.key }}</span>
    </div>
    <div class="c-single-image-drawer-body">
      <div class="c-single-image-info">
        <p class="c-single-image-info-row">
          <md-icon>folder</md-icon>
          <span class="c-single-image-info-name">Path:</span>
          <span class="c-single-image-info-value">{{ cloudflareImage?.fullPath }}</span>
          <button
            class="c-single-image-info-copy"
            @click="copyToClipboard(cloudflareImage?.fullPath)"
          >
            <md-icon>file_copy</md-icon>
          </button>
        </p>
        <p class="c-single-image-info-row">
          <md-icon>insert_drive_file</md-icon>
          <span class="c-single-image-info-name">Name:</span>
          <span class="c-single-image-info-value">{{ cloudflareImage?.key }}</span>
        </p>
        <p class="c-single-image-info-row">
          <md-icon>calendar_today</md-icon>
          <span class="c-single-image-info-name">Last Modified:</span>
          <span class="c-single-image-info-value">{{ cloudflareImage?.lastModified | date }}</span>
        </p>
        <p class="c-single-image-info-row">
          <md-icon>storage</md-icon>
          <span class="c-single-image-info-name">Size:</span>
          <span class="c-single-image-info-value">{{ cloudflareImage?.size | fileSize }}</span>
        </p>
        <p class="c-single-image-info-row">
          <md-icon>link</md-icon>
          <span class="c-single-image-info-name">Direct link:</span>
          <span class="c-single-image-info-value">
            <a
              :href="cloudflareImagePath + '/' + cloudflareImage?.fullPath"
              target="_blank"
            >{{ cloudflareImagePath + '/' + cloudflareImage?.fullPath }}</a>
          </span>
          <button
            class="c-single-image-info-copy"
            @click="copyToClipboard(cloudflareImagePath + '/' + cloudflareImage?.fullPath)"
          >
            <md-icon>file_copy</md-icon>
          </button>
        </p>
      </div>
      <img
        v-if="cloudflareImage?.fullPath"
        class="c-single-image"
        :src="cloudflareImagePath + '/' + cloudflareImage?.fullPath"
        :alt="cloudflareImage?.key"
      >
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import moment from "moment/moment";

export default {
  name: 'SingleCloudflareImageDrawer',

  filters: {
    fileSize(bytes) {
      if (bytes === 0) return '0 B';
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(1024));
      return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
    },

    date(dateString) {
      return moment(dateString).format('DD/MM/YYYY HH:mm')
    }
  },

  props: {
    cloudflareImage: {
      type: Object,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      cloudflareImagePath: 'https://img.meridianbet.com'
    };
  },

  methods: {
    ...mapActions("response", ["handleSuccess", "handleError", "resetError"]),

    close() {
      this.$emit("close");
    },

    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.handleSuccess({message: 'URL copied to clipboard'})
      }).catch(() => {
        this.handleError('Failed to copy')
      });
    }
  },
};
</script>

<style
  lang="scss"
  scoped
>
.c-single-image-drawer {
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  border-left: 1px solid rgba($grey-02, .3);
}

.c-single-image-drawer-header {
  display: flex;
  align-items: center;
  padding: 10px;
  background: linear-gradient(to right, rgba($grey-02, .3), transparent);
  gap: 20px;
  margin: 0;

  i {
    font-weight: bold;
    font-size: 32px !important;
  }

  span {
    text-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.c-single-image-drawer-close-button {
  background: none;

  &:hover {
    opacity: .7;
    cursor: pointer;
  }
}

.c-single-image-drawer-body {
  position: relative;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 10px 5px;
}

.c-single-image-info {
  font-size: 14px;
  margin-bottom: 10px;

  i {
    font-size: 16px !important;
  }
}

.c-single-image-info-row {
  display: flex;
  align-items: center;
  gap: 5px;
  text-overflow: ellipsis;
  overflow: hidden;
  text-wrap: nowrap;
  max-width: fit-content;

  .c-single-image-info-name {
    font-weight: bold;
  }

  .c-single-image-info-value {
    overflow: hidden;
    text-wrap: nowrap;
    text-overflow: ellipsis;
    font-family: 'Roboto Condensed', sans-serif;
  }

  &:hover {
    .c-single-image-info-copy {
      visibility: visible;
    }
  }
}

.c-single-image-info-copy {
  visibility: hidden;
  background: none;
  cursor: pointer;

  &:hover {
    opacity: .7;
  }

  i {
    color: $white;
  }

}

.c-single-image {
  max-width: 100%;
  max-height: 100%;
  min-height: 0;
  object-fit: scale-down;
}

</style>
